import React from "react";
import FilterModule from "@/components/discovery/FilterModule";
import { StyledSidebarStack } from "../../styled";
import { SidebarSection } from "../SidebarSection";
import { DescriptionText } from "../DescriptionText";

export const GeneratedFilterSidebar = ({
  hasGeneratedFilters,
  finalSections,
  generatedActiveFilters,
  setGeneratedActiveFilters,
  generatedContentTypes,
  debugMode,
  forceV3,
}) =>
  hasGeneratedFilters ? (
    <FilterModule
      filterConfig={finalSections}
      activeFilters={generatedActiveFilters}
      setActiveFilters={setGeneratedActiveFilters}
      presetActiveFilters={[]}
      contentTypes={generatedContentTypes}
      usedIn="filters-playground"
      debug={debugMode}
      _forceV3={forceV3 || undefined}
    />
  ) : (
    <StyledSidebarStack>
      <SidebarSection
        title="Generated filter module"
        description="Select templates and scopes to generate filters."
      >
        <DescriptionText>
          No filters available. Adjust the configuration to generate filter sections.
        </DescriptionText>
      </SidebarSection>
    </StyledSidebarStack>
  );


